import { IBetErrorDoc } from '@frontend/oxygen/shared-utils';

export class BetError {
    code: string;
    subCode: string;
    desc: string;
    outcomeId: string | undefined;
    legDocId: string;

    constructor(params: IBetErrorDoc) {
        this.code = params.code;
        this.subCode = params.subErrorCode;
        this.desc = params.errorDesc;
        this.outcomeId = params.outcomeRef && params.outcomeRef[0]?.id;
        this.legDocId = params.legRef && params.legRef.documentId;
    }
}
